import { createRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { Route as rootRoute } from 'src/pages/__root';
import { PortalBrandTheme } from './brandTheme';
import { PortalLoginPanel } from './PortalLoginPanel';
import { cannedBrandTokens } from './cannedPortal';
import {
  isPortalLoggedIn,
  portalCredentialsValid,
  setPortalLoggedIn,
} from './portal-session';

/**
 * Public, branded login for the demo portal. Independent of the real auth
 * stack: it checks the canned credentials and flips the local portal session.
 */
export const portalLoginRoute = createRoute({
  path: '/portal/login',
  getParentRoute: () => rootRoute,
  beforeLoad: () => {
    if (isPortalLoggedIn()) {
      throw redirect({ to: '/portal' });
    }
  },
  component: PortalLoginPage,
});

function PortalLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!portalCredentialsValid(email, password)) {
      setError('Those credentials don’t match. Try again.');
      return;
    }
    setPortalLoggedIn(true);
    void navigate({ to: '/portal' });
  }

  return (
    <PortalBrandTheme
      tokens={cannedBrandTokens}
      className="min-h-svh flex flex-col items-center justify-center px-4"
    >
      <PortalLoginPanel
        email={email}
        password={password}
        error={error}
        onEmailChange={(value) => {
          setEmail(value);
          setError('');
        }}
        onPasswordChange={(value) => {
          setPassword(value);
          setError('');
        }}
        onSubmit={handleSubmit}
      />
    </PortalBrandTheme>
  );
}
